module.exports = __webpack_public_path__ + "img/user-management.3f672c31.svg";